var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import "./sectionHeader.css";
/**
 * This is the SectionHeader
 * It is the text that separates sections like Dashboard, Emplyability (Graphs)
 * It is typically used within the Bar element
 */
export default function SectionHeader(props) {
    return _jsx("p", __assign({ className: "section-header align-middle my-auto" }, { children: props.title }));
}
